import { queryOptions } from "@tanstack/react-query";

import type { CompanyDetail, CompanyOption, CompanySummary } from "@kansai-ai-hub/api-client";

import { apiClient } from "@/lib/api-client";
import { fetchAllPaginated } from "@/lib/fetch-all-pages";

export const companyKeys = {
  all: ["companies"] as const,
  list: () => [...companyKeys.all, "list"] as const,
  options: (scope: "cases" | "applications") => [...companyKeys.all, "options", scope] as const,
  detail: (id: string) => [...companyKeys.all, "detail", id] as const,
} as const;

/**
 * 企業名フィルタ用の組織候補（ページング上限なし・DBから動的算出）。
 * - `"cases"`: 案件を持つ全組織（案件一覧フィルタ用）
 * - `"applications"`: 応募がある組織のみ（応募管理フィルタ用）
 */
export function companyOptionsQueryOptions(scope: "cases" | "applications" = "cases") {
  return queryOptions({
    queryKey: companyKeys.options(scope),
    queryFn: () =>
      apiClient.get<CompanyOption[]>("/api/v1/companies/options", { query: { scope } }),
    staleTime: 60_000,
  });
}

/** 参加企業ディレクトリ。会員はカード一覧で全社を閲覧するため全件取得する（既定ページ上限で切れない）。 */
export function companiesListQueryOptions() {
  return queryOptions({
    queryKey: companyKeys.list(),
    queryFn: () => fetchAllPaginated<CompanySummary>("/api/v1/companies"),
    staleTime: 60_000,
  });
}

export function companyDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: companyKeys.detail(id),
    queryFn: () => apiClient.get<CompanyDetail>(`/api/v1/companies/${id}`),
    staleTime: 60_000,
  });
}
